export const validateSecurityForm = (formData, setFormErrorMessages) => {
  setFormErrorMessages({});
  let isValid = true;
  const errors = {};

  if (!formData.oldPassword) {
    errors.oldPassword = 'Old password is required';
    isValid = false;
  }
  if (!formData.newPassword) {
    errors.newPassword = 'New password is required';
    isValid = false;
  }
  if (!formData.confirmPassword) {
    errors.confirmPassword = 'Confirm password is required';
    isValid = false;
  } else if (formData.newPassword !== formData.confirmPassword) {
    errors.confirmPassword = 'New and Confirm passwords do not match';
    isValid = false;
  }

  const isComplex = /^(?=.*\d)(?=.*[A-Z])(?=.*[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]).{8,}$/.test(formData.newPassword);
  if (formData.newPassword && !isComplex) {
    errors.newPassword = 'Password needs at least 8 characters, 1 number, 1 special char, 1 uppercase, and 1 lowercase.';
    isValid = false;
  }

  setFormErrorMessages(errors);
  return isValid;
};

export default validateSecurityForm;
